import { render, staticRenderFns } from "./GroupActions.vue?vue&type=template&id=712043e7"
import script from "./GroupActions.js?vue&type=script&lang=js&external"
export * from "./GroupActions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports